export enum BarrierStatus {
  ToPutEffort = 'A travailler',
  InProgress = 'En cours',
  Resolved = 'Résolu',
  Aborted = 'Abandonné',
}

export const labelsByBarrierStatus: Map<BarrierStatus, string> = new Map<BarrierStatus, string>(
  Object.keys(BarrierStatus).map((x: string) => [x, BarrierStatus[x]] as [BarrierStatus, string]),
);
